export default __webpack_public_path__ + "static/media/evas05.247cfa02.jpg";